import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

const WEEKS_BACK = 10;

export const toSucataTimestamp = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'number') return value;
  const parsed = moment(value);
  return parsed.isValid() ? parsed.valueOf() : null;
};

const getMondayOfWeek = (date) => moment(date).startOf('isoWeek');

const formatPeriodoLabel = (inicio, fim) =>
  `${moment(inicio).format('DD/MM/YYYY')} - ${moment(fim).format('DD/MM/YYYY')}`;

export const buildPeriodoOptionId = (periodoInicio, periodoFim) => {
  const inicio = toSucataTimestamp(periodoInicio);
  const fim = toSucataTimestamp(periodoFim);
  if (!inicio || !fim) return '';
  return `${inicio}_${fim}`;
};

const periodoOptionFromMonday = (monday) => {
  const periodoInicio = monday.clone().startOf('day').valueOf();
  const periodoFim = monday.clone().add(6, 'days').startOf('day').valueOf();
  const id = buildPeriodoOptionId(periodoInicio, periodoFim);

  return {
    id,
    nome: formatPeriodoLabel(periodoInicio, periodoFim),
    periodoInicio,
    periodoFim,
  };
};

const periodoOptionFromDates = (periodoInicio, periodoFim) => {
  const inicio = toSucataTimestamp(periodoInicio);
  const fim = toSucataTimestamp(periodoFim);

  return {
    id: buildPeriodoOptionId(inicio, fim),
    nome: formatPeriodoLabel(inicio, fim),
    periodoInicio: inicio,
    periodoFim: fim,
  };
};

const isSamePeriodo = (aInicio, aFim, bInicio, bFim) =>
  moment(aInicio).isSame(moment(bInicio), 'day')
  && moment(aFim).isSame(moment(bFim), 'day');

export const getPeriodoOptions = (referenceDate = moment()) => {
  const currentMonday = getMondayOfWeek(referenceDate);
  const options = [];

  for (let i = 0; i <= WEEKS_BACK; i += 1) {
    options.push(periodoOptionFromMonday(currentMonday.clone().subtract(i, 'weeks')));
  }

  return options;
};

export const findPeriodoOptionId = (periodoInicio, periodoFim, options) => {
  const match = (options || []).find((option) =>
    isSamePeriodo(option.periodoInicio, option.periodoFim, periodoInicio, periodoFim)
  );
  return match ? match.id : '';
};

export const resolvePeriodoOptions = (sucata, referenceDate = moment()) => {
  const options = getPeriodoOptions(referenceDate);

  if (!sucata?.periodoInicio || !sucata?.periodoFim) {
    return options;
  }

  const existingId = findPeriodoOptionId(sucata.periodoInicio, sucata.periodoFim, options);
  if (existingId) {
    return options;
  }

  return [periodoOptionFromDates(sucata.periodoInicio, sucata.periodoFim), ...options];
};

export const getPeriodoFromOptionId = (periodoOptionId, options) => {
  const option = (options || []).find((item) => item.id === periodoOptionId);
  if (!option) return null;
  return {
    periodoInicio: option.periodoInicio,
    periodoFim: option.periodoFim,
  };
};
